import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import GroupRadioButton from './GroupRadioButton';

import './GroupRadioButtonsList.custom.scss';

export default function GroupRadioButtonsList (props) {
  const { group } = props;
  const optionsIds = group.get('optionsIds');
  const options = group.get('options');

  return (
    <>
      {
        optionsIds
          .map((id) => {
            return (
              <GroupRadioButton
                {...props}
                key={id}
                optionId={id}
                option={options.get(id)}
              />
            );
          })
      }
    </>
  );
}

GroupRadioButtonsList.propTypes = {
  groupId: PropTypes.string.isRequired,
  group: PropTypes.instanceOf(Map).isRequired,
};
